export default "__VITE_ASSET__Dz_vmy30__"